// Utils
import Dictionary from '@/types/dictionary';
import { DISCLAIMER_KEYS } from './constants';
import helpers from './helpers';
import Disclaimer from '@/types/disclaimer';
import ComparisonBenchmark from '@/types/comparison-benchmark';

/**
 * Generates the disclaimers to be used inside a comparison for a benchmark.
 * @param {ComparisonBenchmark} benchmark Benchmark used to generate the disclaimers.
 * @returns {Dictionary<Disclaimer>} Dictionary of disclaimer keys
 */
export const getComparisonBenchmarkDisclaimers = (benchmark: ComparisonBenchmark): Dictionary<Disclaimer> => {
  const disclaimers: Dictionary<Disclaimer> = {};
  const firstDataDate = helpers.getFirstDataPointDate(benchmark);
  const lastDataDate = helpers.getLastDataPointDate(benchmark);

  // Generic disclaimer with the date of the first data point -- used for time-based data fields.
  disclaimers[DISCLAIMER_KEYS.BENCHMARK_NO_DATA_BEFORE_DATE] = {
    key: DISCLAIMER_KEYS.BENCHMARK_NO_DATA_BEFORE_DATE,
    data: {
      date: firstDataDate,
    },
  };

  if (helpers.holdingIsClosed(benchmark)) {
    disclaimers[DISCLAIMER_KEYS.BENCHMARK_CLOSED] = {
      key: DISCLAIMER_KEYS.BENCHMARK_CLOSED,
      data: {
        date: lastDataDate,
      },
    };
  }

  // Disclaimers related to missing data
  if (helpers.holdingHasNoData(benchmark)) {
    disclaimers[DISCLAIMER_KEYS.BENCHMARK_NO_DATA] = {
      key: DISCLAIMER_KEYS.BENCHMARK_NO_DATA,
    };

    disclaimers[DISCLAIMER_KEYS.BENCHMARK_NO_RISK_METRICS] = {
      key: DISCLAIMER_KEYS.BENCHMARK_NO_RISK_METRICS,
    };
  }

  if (helpers.holdingHasLessThan1YData(benchmark)) {
    disclaimers[DISCLAIMER_KEYS.BENCHMARK_LESS_THAN_1Y] = {
      key: DISCLAIMER_KEYS.BENCHMARK_LESS_THAN_1Y,
      data: {
        date: firstDataDate,
      },
    };

    disclaimers[DISCLAIMER_KEYS.BENCHMARK_NO_RISK_METRICS] = {
      key: DISCLAIMER_KEYS.BENCHMARK_NO_RISK_METRICS,
    };
  }

  if (helpers.holdingHasLessThan3YData(benchmark)) {
    disclaimers[DISCLAIMER_KEYS.BENCHMARK_LESS_THAN_3Y] = {
      key: DISCLAIMER_KEYS.BENCHMARK_LESS_THAN_3Y,
      data: {
        date: firstDataDate,
      },
    };
  }

  disclaimers[DISCLAIMER_KEYS.RISK_METRICS_NOT_ENOUGH_DATA] = {
    key: DISCLAIMER_KEYS.RISK_METRICS_NOT_ENOUGH_DATA,
  };

  return disclaimers;
};
